import React, { useState, useEffect } from 'react';
import { Layout, Modal } from 'antd';
import ContentHeader from '../../components/layout/ContentHeader';
import Summary from '../../components/reports/form/Summary';
import DangerRatings from '../../components/reports/form/DangerRatings';

import { connect } from 'react-redux'
import Hazards from '../../components/reports/form/Hazards';
import MoreDetails from '../../components/reports/form/MoreDetails';
import axios from 'axios'
import { setNewReportLoading, setLogout, setNewReportEmpty, fetchGlobal, setReportEditData } from '../../redux'
import { apiBaseUrl } from '../../config/api'
import Loader from '../../components/feedback/Loader';


const { Content } = Layout;

function EditReport({ newReport, setNewReportLoading, setLogout, history, user, setNewReportEmpty, fetchGlobal, match, setReportEditData }) {
    const [step, setStep] = useState(1)

    useEffect(() => {
        if (!user.details.type) {
            history.push('/login')
        } 
        
    }, [user.details.type, history]);

    useEffect(() => {

        setNewReportLoading(true)
        axios(
            {
                method: 'POST',
                url: apiBaseUrl + "report/get",
                headers: { auth_key: localStorage.getItem('sessionKey') },
                data: { id: match.params.id }
            })
            .then(response => {
                // console.log(response)

                if (response.data.status === 401) {
                    setLogout(localStorage.getItem('sessionKey'))
                } else if (response.data.status === 1) {
                    setReportEditData(response.data)
                } else {
                    showError(response.data.message)
                }
                setNewReportLoading(false)
            })
            .catch(error => {
                const errorMsg = error.message
                showError(errorMsg)
                setNewReportLoading(false)
            })

    }, [match.params.id, setLogout, setNewReportLoading, setReportEditData]);



    function prev(id) {
        setStep(id)
    }

    function save() {
        setNewReportLoading(true)
        axios(
            {
                method: 'POST',
                url: apiBaseUrl + "report/edit",
                headers: { auth_key: localStorage.getItem('sessionKey') },
                data: { report: newReport, id: match.params.id }
            })
            .then(response => {
                console.log(response)

                if (response.data.status === 401) {
                    setLogout(localStorage.getItem('sessionKey'))
                } else if (response.data.status === 1) {
                    success()
                } else {
                    showError(response.data.message)
                }
                setNewReportLoading(false)
            })
            .catch(error => {
                const errorMsg = error.message
                showError(errorMsg)
                setNewReportLoading(false)
            })
    }

    function success() {
        Modal.success({
            content: 'Report has been successfully updated.',
            onOk() { afterSuccess() },
        });
    }

    function afterSuccess() {
        setNewReportEmpty()
        fetchGlobal()
        history.push('/reports')
    }

    function showError(msg) {
        Modal.error({
            content: msg,
        });
    }

    return (
        <div>
            <ContentHeader title="Edit Report" />

            <Content style={{ margin: '24px 16px 0' }}>
                <div className="site-layout-background">

                    {
                        (step === 1)
                            ?
                            <Summary setStep={setStep} />
                            :
                            (step === 2)
                                ?
                                <DangerRatings setStep={setStep} prev={prev} img_type="edit"/>
                                :
                                (step === 3)
                                    ?
                                    <Hazards next={setStep} prev={prev} img_type="edit"/>
                                    :
                                    <MoreDetails next={save} prev={prev} img_type="edit"/>
                    }


                    <br />
                </div>
                {(newReport.loading ? <Loader title="Loading..." /> : null)}
            </Content>
        </div>
    );
}


const mapStateToProps = state => {
    return {
        newReport: state.newReport,
        user: state.user,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setNewReportLoading: (bool) => dispatch(setNewReportLoading(bool)),
        setLogout: (key) => dispatch(setLogout(key)),
        setNewReportEmpty: () => dispatch(setNewReportEmpty()),
        fetchGlobal: () => dispatch(fetchGlobal()),
        setReportEditData: (obj) => dispatch(setReportEditData(obj)),
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(EditReport);
